
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {deleteScreen, impactedTestcase, toysInScreen} from "@/axios/repository/screen.axios";
import {Location} from "vue-router";
import {createPassport} from "@/shared/local.storage.utils";

interface ITc {
  _id: string,
  name: string
}

@Component
export default class DeleteDialog extends Vue {
  // Les props
  @Prop({default: null}) private what!: string
  @Prop({default: null}) private id!: string
  @Prop({default: null}) private name!: string

  // Les propriétés
  private isVisible: boolean = false
  private impactedTc: ITc[] = []
  private errorMsg: string | null = null
  private nbToys: number = 0

  // Les propriétés calculées
  private get whatMsg() {
    return this.what === 'tobject' ? 'Item' : this.what === 'screen' ? 'Screen' : ''
  }

  private get deleteName() {
    return this.name ? `${this.whatMsg} <${this.name}>` : ''
  }

  // Les hooks
  // Les méthodes surveillées
  @Watch('isVisible')
  private async loadTcImpact() {
    if (this.isVisible) {
      const result = await impactedTestcase(this.what, this.id)
      if (typeof result === "string") {
        // Erreur => procédure d'abandon => delete impossible
        this.errorMsg = result as string
      } else {
        this.impactedTc = result as ITc[]
        this.errorMsg = null
      }
      if (this.what === 'screen') {
        this.nbToys = await toysInScreen(this.id)
      }
    }
  }

  // Les méthodes d'instance
  private to(tcid: string): Location {
    if (this.$store.state.current.Project) {
      const prjid = this.$store.state.current.Project._id
      const passport = createPassport(prjid, tcid)
      return {name: 'testcase.workspace', params: {passport}}
    } else {
      return {name: 'testcase.workspace'}
    }
  }

  private async onDelete() {
    if (this.what === 'screen') {
      await deleteScreen(this.id)
    }
    this.$emit('deleted')
    this.isVisible = false

  }

  // Les méthodes statiques
}
